import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HelpCenter from "../components/help-center"

const HelpCenterPage = () => {
  return (
    <Layout page="Help Center">
      <SEO title="Help Center" />
      <HelpCenter />
    </Layout>
  )
}

export default HelpCenterPage
